import { useSubscriptionCRUDActions } from '@mm/state/actions/SubscriptionCRUDActions';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';

export const useBudgetCap = ({
  subscription,
  onSuccess,
}: {
  subscription?: SubscriptionModel | undefined;
  onSuccess?: () => void;
}) => {
  const { openBudgetCapsModal, closeModal } = useModalActions();
  const { update: updateSubscription } = useSubscriptionCRUDActions();
  const thisPeriodBillCombinedInfo =
    (subscription?.currentInvoiceAmount?.sum || 0) / 100;

  const onUpdateBudgetCap = async (budgetCap: number | null) => {
    if (subscription && budgetCap !== subscription.budgetCap) {
      await updateSubscription(subscription.id, { budgetCap });
      onSuccess?.();
    }

    closeModal();
  };

  const subscriptionPriceWithExtra =
    (subscription?.currentInvoiceAmount?.subsPrice || 0) / 100 + 50;

  const defaultLimitValue = subscription?.budgetCap
    ? (subscription?.budgetCap || 0) / 100
    : subscriptionPriceWithExtra;

  const updateBudgetCap = () => {
    openBudgetCapsModal({
      hasBudgetCap: !!subscription?.budgetCap,
      minValue: subscriptionPriceWithExtra,
      defaultValue: defaultLimitValue,
      onSubmit: onUpdateBudgetCap,
    });
  };

  return { updateBudgetCap };
};
